import MaterialProvider from './materialProvider';

export const getMaterialPreviewAsync = MaterialProvider.getMaterialPreviewAsync;

export const getMaterialByIdAsync = MaterialProvider.getMaterialByIdAsync;

export const getMaterialByCategoryAsync = MaterialProvider.getMaterialByCategoryAsync;

export const updateMaterialAsync = MaterialProvider.updateMaterialAsync;

export const getAllMaterialPreviewAsync = MaterialProvider.getAllMaterialPreviewAsync;

export const insertMaterialWithImageAsync = MaterialProvider.insertMaterialWithImageAsync;

export const updateMaterialWithImageAsync = MaterialProvider.updateMaterialWithImageAsync;
